// src/admin/hooks/useAuth.js
import { useEffect, useState, createContext, useContext } from "react";
import { getMe } from "../api/adminApi";

// Create a Context so we can access auth state anywhere in admin
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const auth = useProvideAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

// Hook to use auth context
export default function useAuth() {
  return useContext(AuthContext);
}

// Actual logic hook
function useProvideAuth() {
  const [user, setUser] = useState(null);     // logged-in user object
  const [loading, setLoading] = useState(true); // loading auth state

  useEffect(() => {
    async function init() {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const res = await getMe();
        setUser(res.data);
      } catch (err) {
        localStorage.removeItem("token");
      }
      setLoading(false);
    }
    init();
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  return { user, setUser, loading, logout };
}
